import { Col } from "react-bootstrap";
import "../../Assets/Styles/pages/signIn.scss";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import React from "react";

const SignInCard = ({ loader, src, component, handleClick, text }) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={handleClick}
      className="signIn_card w-100 d-flex justify-content-start px-4 mb-2 py-2 m-2"
    >
      <img className="signIn_logo me-1" src={src} alt="src" />
      {loader === component ? (
        <Col className=" m-0 p-0 d-flex justify-content-center align-items-center">
          <CircularProgress className="themeColor  signInLoader " />
        </Col>
      ) : (
        //SignIn.SignGoogle
        <span className="signIn_google_text text-start  text_16">
          {t(text)}
        </span>
      )}
      {/* apple */}
    </div>
  );
};

export default SignInCard;
